import { COLORS } from '@btime/constants'
import { concatIf } from '@btime/helpers'
import { gql } from '@apollo/client'
import { head, propEq } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { Grid } from '../../packages/kiti/components/structure/Grid'
import { generalClient } from '../../utils/apollo/api'
import { useNavigation } from '../../utils/contexts/NavigationContext'
import { useOpenEditProcessModal } from '../../utils/routes/modals/modalsActions'
import { useQuery } from '../../utils/apollo/_helpers/useQuery'
import { useRemoveProcesses } from './_request/removeScreenRequest'
import DropdownLink from '../../components/navigation/DropdownLink'
import Icon from '../../packages/kiti/components/shapes/Icon'
import IconButton from '../../components/actions/IconButton'
import Link from '../../packages/kiti/components/actions/Link'
import Loading from '../../packages/kiti/components/helpers/Loading'

const QUERY = gql`
  query Screens($filter: ScreenFilter) {
    screens(filter: $filter, limit: 100, sort: { field: NAME, type: ASC }) {
      id
      name
    }
  }
`

const getProcessViewType = path => {
  const parts = path.split('/')
  return parts[2]
}

const ProcessesDropdown = ({ selected, screen }) => {
  const navigate = useNavigation()
  const canCreateProcesses = useSessionPermission('setupScreen')
  const openEditProcesses = useOpenEditProcessModal()
  const [removeProcesses, { loading }] = useRemoveProcesses()
  const viewType = getProcessViewType(selected)

  const { data } = useQuery(QUERY, {
    fetchPolicy: 'cache-first',
    client: generalClient,
    variables: { filter: { screens: screen } }
  })

  const handleRemoveFilter = processId => e => {
    e.stopPropagation()
    removeProcesses(processId)
    if (`/processes/${viewType}/${processId}` === selected) {
      navigate(`/processes`)
    }
  }

  if (loading) return <Loading />

  const options = [
    ...(data?.screens || []).map(screen => ({
      label: screen.name,
      value: `/processes/${viewType}/${screen.id}`,
      iconLeft: 'BsKanban',
      onClick: () => navigate(`/processes/${viewType}/${screen.id}`),
      rightContent: canCreateProcesses && (
        <Grid gap={0.6}>
          <Link onClick={() => openEditProcesses({ id: screen.id })}>
            <Icon name="BsPencil" size={0.8} color="dark3" />
          </Link>
          <Link onClick={() => openEditProcesses({ id: screen.id, isCloning: true })}>
            <Icon name="BsLayers" size={0.8} color="dark3" />
          </Link>
          <Link onClick={handleRemoveFilter(screen.id)}>
            <Icon name="BsTrash" size={0.8} color="red" />
          </Link>
        </Grid>
      )
    })),

    ...concatIf(canCreateProcesses, [
      {
        label: 'Novo processo',
        value: 'new',
        iconLeft: 'BsBookmarkPlus',
        onClick: () => openEditProcesses({ initialState: { screen } }),
        color: COLORS.purple
      }
    ])
  ]

  const activeOption = options.find(propEq('value', selected)) || head(options)

  return (
    <DropdownLink
      actionContent={<IconButton iconLeft={activeOption?.iconLeft} label={activeOption?.label} transparent noWrap />}
      options={options}
    />
  )
}

export default ProcessesDropdown
